/**
 * @typedef {number} EventAccessStatus
 */

//-----------------------------------------------------------------------------

/** @type {EventAccessStatus} */
export const EVENT_ACCESS_STATUS__OPEN      = 0;

/** @type {EventAccessStatus} */
export const EVENT_ACCESS_STATUS__BLOCKED   = 1;

/** @type {EventAccessStatus} */
export const EVENT_ACCESS_STATUS__UNBLOCKED = 2;

//-----------------------------------------------------------------------------

/**
 * @param {EventAccessStatus} eventAccessStatus
 * @returns {boolean}
 */
export function isEventAccessBlocked(eventAccessStatus) {
  return eventAccessStatus === EVENT_ACCESS_STATUS__BLOCKED;
}

//-----------------------------------------------------------------------------

/**
 * @param {EventAccessStatus} eventAccessStatus
 * @returns {string}
 */
export function getEventAccessStatusName(eventAccessStatus) {
  switch(eventAccessStatus) {
    case EVENT_ACCESS_STATUS__OPEN:      return 'open';
    case EVENT_ACCESS_STATUS__BLOCKED:   return 'blocked';
    case EVENT_ACCESS_STATUS__UNBLOCKED: return 'unblocked';
  }
  return `Unknown event access status ${eventAccessStatus}.`;
}

/**
 * @param {EventAccessStatus} eventAccessStatus
 * @returns {string}
 */
export function getEventAccessStatusNameRu(eventAccessStatus) {
  switch(eventAccessStatus) {
    case EVENT_ACCESS_STATUS__OPEN:      return 'открыт';
    case EVENT_ACCESS_STATUS__BLOCKED:   return 'заблокирован';
    case EVENT_ACCESS_STATUS__UNBLOCKED: return 'разблокирован';
  }
  return `Unknown event access status ${eventAccessStatus}.`;
}

/**
 * @param {EventAccessStatus} eventAccessStatus
 * @returns {boolean}
 */
export function isEventAccessCanBeOpen(eventAccessStatus) {
  return eventAccessStatus !== EVENT_ACCESS_STATUS__OPEN;
}

/**
 * @param {EventAccessStatus} eventAccessStatus
 * @returns {boolean}
 */
export function isEventAccessCanBeBlocked(eventAccessStatus) {
  switch(eventAccessStatus) {
    case EVENT_ACCESS_STATUS__OPEN:      return true;
    case EVENT_ACCESS_STATUS__UNBLOCKED: return true;
  }
  return false;
}

/**
 * @param {EventAccessStatus} eventAccessStatus
 * @returns {boolean}
 */
export function isEventAccessCanBeUnblocked(eventAccessStatus) {
  return eventAccessStatus === EVENT_ACCESS_STATUS__BLOCKED;
}

/**
 * @param {EventAccessStatus} eventAccessStatus
 * @returns {Object}
 */
export function getEventAccessStatusClass(eventAccessStatus) {
  if(eventAccessStatus === EVENT_ACCESS_STATUS__BLOCKED) {
    return {
      'text-danger': true
    };
  }

  return null;
}
